import React from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/app/hooks";
import { PulseLoader } from "react-spinners";
import { toast } from "react-toastify";
import { approveKyc } from "../../../redux/features/kycSlice";
// import your actual approveKyc action

interface ConfirmApproveKycModalProps {
  isOpen: boolean;
  onClose: () => void;
  userId: string;
  kycStatus: string;
  onApproved?: () => void;
}

const ConfirmApproveKycModal: React.FC<ConfirmApproveKycModalProps> = ({
  isOpen,
  onClose,
  userId,
  kycStatus,
  onApproved,
}) => {
  const { approving } = useAppSelector((state) => state.kyc);
  const dispatch = useAppDispatch();

  const handleApprove = async () => {
    try {
      await dispatch(
        approveKyc({ userId, status: kycStatus, verified: true })
      ).unwrap();
      onApproved?.();
      onClose();
    } catch (error: any) {
      toast.error(error?.message ?? "Failed to approve KYC.");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white w-full max-w-md rounded-lg p-6 shadow-lg">
        <div className="flex justify-center mb-4">
          <div className="bg-green-100 text-green-600 rounded-full p-4">✅</div>
        </div>
        <h2 className="text-center text-xl font-semibold mb-2">Approve KYC</h2>
        <p className="text-center text-gray-600 mb-6">
          Are you sure you want to approve this user's KYC?
        </p>
        <div className="flex justify-between">
          <button
            onClick={onClose}
            className="w-1/2 bg-gray-100 text-gray-800 rounded-md py-2 px-4 mr-2 hover:bg-gray-200"
          >
            Cancel
          </button>
          <button
            onClick={handleApprove}
            className="w-1/2 bg-green-600 text-white rounded-md py-2 px-4 hover:bg-green-700"
          >
            {approving ? <PulseLoader size={6} color="#fff" /> : "Yes, Approve"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmApproveKycModal;
